// DashboardColorContext.tsx
import { createContext, useContext } from "react";

export const DashboardColorContext = createContext<string>("#1A3A67");

export const useDashboardColor = () => useContext(DashboardColorContext);
